<template>
  <div>
    <listaEvaluaciones />
  </div>
</template>
<script>
  import listaEvaluaciones from '../salle/docente/evaluaciones/listaEvaluaciones.vue';
  export default{
    components:{
      listaEvaluaciones
    },
    data(){
      return{

      }
    }
  }
</script>
